import { createRootRoute, Outlet, useLocation } from "@tanstack/react-router";
import { useEffect } from "react";

import AuthProvider from "$/lib/providers/AuthProvider";
import QueryClientProvider from "$/lib/providers/QueryClientProvider";

import { ProfileProvider } from "./_user-layout/profile/-features/providers/ProfileProvider";

export const Route = createRootRoute({
  component: () => (
    <QueryClientProvider>
      <AuthProvider>
        <ProfileProvider>
          <ResetZoomOnNavigate />
          <Outlet />
        </ProfileProvider>
      </AuthProvider>
    </QueryClientProvider>
  ),
});

// Sur mobile, un précédent pinch-zoom reste actif lors d'un changement de page
// en navigation SPA (le meta viewport n'est réappliqué qu'au rechargement complet).
// On force un reset du zoom à chaque changement de route pour que la page
// arrive toujours centrée à l'échelle 1, sans bloquer le pinch-zoom manuel.
function ResetZoomOnNavigate() {
  const { pathname } = useLocation();

  useEffect(() => {
    const viewport = document.querySelector('meta[name="viewport"]');
    if (!viewport) return;

    const original = viewport.getAttribute("content");
    if (!original) return;

    viewport.setAttribute("content", `${original}, maximum-scale=1.0`);
    window.scrollTo(0, 0);

    const timeout = window.setTimeout(() => {
      viewport.setAttribute("content", original);
    }, 100);

    return () => window.clearTimeout(timeout);
  }, [pathname]);

  return null;
}
